import { createMetaReducer, EventsMap } from 'redux-beacon';
import GoogleTagManager from '@redux-beacon/google-tag-manager';

const gtm = GoogleTagManager();

export function createEventsMetaReducer(eventsMap: EventsMap): any {
  return createMetaReducer(eventsMap, gtm);
}